uniform vec2 uFrequency;
uniform float uTime;

varying vec2 vUv;
varying float vElevation;
varying vec3 vNormal;
varying vec3 vPosition;

void main()
{
    vec4 modelPosition = modelMatrix * vec4(position, 1.0);

    // Chapdan o'ngga kuchayib boruvchi to'lqin (UV dan foydalanamiz)
    float waveStrength = pow(uv.x, 1.2);

    // Asosiy to'lqinlar
    float wave1 = sin(uv.x * uFrequency.x * 3.14159 - uTime * 3.0) * 0.15;
    float wave2 = sin(uv.y * uFrequency.y * 6.28318 - uTime * 2.5) * 0.05;
    float wave3 = sin((uv.x * 2.0 + uv.y) * 4.0 - uTime * 2.0) * 0.03;

    float elevation = (wave1 + wave2 + wave3) * waveStrength;
    modelPosition.z += elevation;

    // Bayroq uchi biroz pastga tushsin
    modelPosition.y -= waveStrength * 0.05;

    vec4 viewPosition = viewMatrix * modelPosition;
    vec4 projectedPosition = projectionMatrix * viewPosition;

    gl_Position = projectedPosition;

    // Normal hisoblash
    float nx = cos(uv.x * uFrequency.x * 3.14159 - uTime * 3.0) * uFrequency.x * 0.15 * waveStrength;
    float ny = cos(uv.y * uFrequency.y * 6.28318 - uTime * 2.5) * uFrequency.y * 0.05 * waveStrength;
    vec3 computedNormal = normalize(vec3(-nx * 0.5, -ny * 0.3, 1.0));
    vNormal = normalMatrix * computedNormal;

    vUv = uv;
    vElevation = elevation;
    vPosition = modelPosition.xyz;
}
